var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profileWrapper" }, [
    _c("h1", [_vm._v("My Profile")]),
    _vm._v(" "),
    this.$store.getters.getUser
      ? _c("div", { staticClass: "data" }, [
          _c("div", { staticClass: "dataPart" }, [
            _c("h3", [_vm._v("Username")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(this.$store.getters.getUser.username))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dataPart" }, [
            _c("h3", [_vm._v("Name")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(this.$store.getters.getUser.firstname))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dataPart" }, [
            _c("h3", [_vm._v("Surname")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(this.$store.getters.getUser.lastname))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dataPart" }, [
            _c("h3", [_vm._v("E-Mail")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(this.$store.getters.getUser.email_address))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dataPart" }, [
            _c("h3", [_vm._v("Phone")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(this.$store.getters.getUser.phone_number))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dataPart" }, [
            _c("h3", [_vm._v("Language")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(this.$store.getters.getUser.language))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "edit" }, [
      _c(
        "div",
        { staticClass: "language" },
        [
          _c("h3", [_vm._v("Dashboard Language")]),
          _vm._v(" "),
          _c("v-select", {
            attrs: { label: "language", options: _vm.languages },
            model: {
              value: _vm.languageSelected,
              callback: function($$v) {
                _vm.languageSelected = $$v
              },
              expression: "languageSelected"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6038b4da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6038b4da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/profile-component.vue
// module id = null
// module chunks = 